import { useState } from "react";
import styles from "./style.module.scss";
import { FormSelect } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { getCatalog, getEngines } from "../../../../redux/selectors";
import { useFormik } from "formik";
import api from "../../../../api";
import { toast } from "react-toastify";

const Detail = () => {
  const engines = useAppSelector((state) => getEngines(state));
  const [engineId, setEngineId] = useState<number>(0);
  const [selectedFile, setSelectedFile] = useState<any>(null);

  function handleFileUpload(event: any) {
    setSelectedFile(event.target.files[0]);
  }

  const formik = useFormik({
    initialValues: {
      catalogId: 0,
      amount: "",
      price: "",
      detailName: "",
      catalogType: "",
      vinNumber: "",
      description: "Пока что пусто",
    },
    onSubmit: ({
      amount,
      price,
      detailName,
      vinNumber,
      description,
      catalogType,
    }) => {
      const newDetail = new FormData();
      newDetail.append("file", selectedFile);
      newDetail.append("detailName", detailName);
      newDetail.append("catalogType", catalogType);
      newDetail.append("amount", amount);
      newDetail.append("price", price);
      newDetail.append("vinNumber", vinNumber);
      newDetail.append("description", description);

      // console.log(newDetail);
      // try {  
      if (engineId == 0) {
        toast("Вы не выбрали мотор", { type: "error" });
      } else {
        api.addNewDetail(newDetail, engineId).then((res) => {
          console.log(res);
          toast("Добавленно в каталог " + catalogType, { type: "success" });
        });
      }
      // })
      // } catch (error) {
      // console.log(error);
      // toast("Ошибка, попробуйте еще раз!", {
      //   type: "error",
      //   position: "top-right",
      // });
      // }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className={styles.root}>
      <div className={styles.selects}>
        <p>Если она зависит от мотора Выберите Мотор</p>
        <FormSelect
          required
          className={""}
          onChange={(event: any) => setEngineId(event.target.value)}
        >
          <option value={0}>Без мотора</option>

          {engines.map((e: any) => (
            <option key={e.engineId} value={e.engineId}>
              {e.engineName}
            </option>
          ))}
        </FormSelect>
        {/* <p>Имя каталога</p>

        <FormSelect
          required
          onChange={(event: any) => setCatalogType(event.target.value)}
        >
          {catalogs.map((e) => (
            <option key={e.catalogId} value={e.catalogName}>
              {" "}
              {e.catalogName}
            </option>
          ))}
          <option value={"Другое"}> Другое</option>
        </FormSelect> */}
      </div>
      <div className={styles.inputs}>
        <input
          type="text"
          id="catalogType"
          name="catalogType"
          onChange={formik.handleChange}
          placeholder="Напишите каталог"
          required
        />
        <input
          type="text"
          id="detailName"
          name="detailName"
          onChange={formik.handleChange}
          placeholder="Имя детали"
          required
        />
        <input
          required
          id="amount"
          onChange={formik.handleChange}
          type="text"
          placeholder="Количество"
        />
        <input
          required
          id="price"
          onChange={formik.handleChange}
          type="text"
          placeholder="Цена"
        />
        <input
          required
          id="vinNumber"
          onChange={formik.handleChange}
          type="text"
          placeholder="vin-номер"
        />
        <input
          type="file"
          onChange={handleFileUpload}
          placeholder="Выберите фотографию"
          required
        />
        <button type="submit">Создать Деталь</button>
      </div>
    </form>
  );
};

export default Detail;
